module.exports = __webpack_public_path__ + "img/jcb.a01fe9c2.svg";